import { cn } from '@/lib/utils';

/**
 * Portfolio navigation icon. Colors via `currentColor` so the parent's
 * text color (and `transition-colors`) drives the active/inactive animation.
 *
 * @param active - When `true`, plays the chart animation: bars grow from the
 *   baseline (staggered) and the trend line draws in (keyframes in
 *   `index.css`, keyed on the `data-active` attribute). The bars are the
 *   first four `<path>`s and the trend line is the sixth — the CSS targets
 *   them by source order, so element order here must not change.
 */
export function PortfolioIcon({ active, className, ...props }: React.SVGProps<SVGSVGElement> & { active?: boolean }) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('nav-icon nav-icon--portfolio', className)}
      data-active={active ? 'true' : undefined}
      {...props}
    >
      <path
        d="M7.57242 21.9805H3.32715C2.92965 21.9805 2.60742 22.2833 2.60742 22.6569V27.2259C2.60742 27.5994 2.92965 27.9023 3.32715 27.9023H7.57242C7.96991 27.9023 8.29214 27.5994 8.29214 27.2259V22.6569C8.29214 22.2833 7.96991 21.9805 7.57242 21.9805Z"
        fill="currentColor"
      />
      <path
        d="M14.8361 18.3945H10.5908C10.1933 18.3945 9.87109 18.6974 9.87109 19.0709V27.2279C9.87109 27.6015 10.1933 27.9043 10.5908 27.9043H14.8361C15.2336 27.9043 15.5558 27.6015 15.5558 27.2279V19.0709C15.5558 18.6974 15.2336 18.3945 14.8361 18.3945Z"
        fill="currentColor"
      />
      <path
        d="M22.0998 16.0391H17.8545C17.457 16.0391 17.1348 16.3419 17.1348 16.7155V27.2274C17.1348 27.601 17.457 27.9038 17.8545 27.9038H22.0998C22.4973 27.9038 22.8195 27.601 22.8195 27.2274V16.7155C22.8195 16.3419 22.4973 16.0391 22.0998 16.0391Z"
        fill="currentColor"
      />
      <path
        d="M29.3615 11.1738H25.1162C24.7187 11.1738 24.3965 11.4767 24.3965 11.8502V27.2441C24.3965 27.6177 24.7187 27.9205 25.1162 27.9205H29.3615C29.759 27.9205 30.0812 27.6177 30.0812 27.2441V11.8502C30.0812 11.4767 29.759 11.1738 29.3615 11.1738Z"
        fill="currentColor"
      />
      <path
        d="M29.5615 28.7012H3.05974C2.70746 28.7012 2.42188 28.9694 2.42188 29.3004C2.42188 29.6313 2.70746 29.8996 3.05974 29.8996H29.5615C29.9138 29.8996 30.1994 29.6313 30.1994 29.3004C30.1994 28.9694 29.9138 28.7012 29.5615 28.7012Z"
        fill="currentColor"
      />
      <path
        d="M3.07812 19.738L12.4285 11.4478C12.6697 11.234 13.0405 11.217 13.3026 11.408L16.8397 13.9845C17.1028 14.1761 17.4759 14.158 17.7165 13.9422L29.0942 3.72656"
        pathLength={1}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
